import React, { useEffect, useState } from 'react';
import { Alert, Box, Snackbar, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import OrganizationForm from '../components/OrganizationForm';
import { useDispatch, useSelector } from 'react-redux';
import {
  cancelOrganizationCreate,
  editOrganizationRequest,
  fetchOrganizationById,
  markOrganizationEdited,
} from '../../api/organizations/organizationSlice';
import { selectUser } from '../../api/auth/authSlice';
import { clearSelectedPartner } from '../../api/partners/partnerSlice';

const OrganizationEditPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const user = useSelector(selectUser);
  const { loading, isOrganizationEdited, error, selectedOrganization, is_embedded_partner } = useSelector(
    (state) => state.organizations,
  );
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  useEffect(() => {
    if (error) {
      setSnackbarMessage(`${error}`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
    dispatch(markOrganizationEdited(false));
  }, [error]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchOrganizationById(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (isOrganizationEdited) {
      navigate('/organizations');
    }
  }, [isOrganizationEdited, navigate]);

  const handleUpdate = async (data) => {
    dispatch(editOrganizationRequest(data));
  };

  function handleCancel() {
    dispatch(cancelOrganizationCreate());
    dispatch(clearSelectedPartner());
    return navigate('/organizations');
  }

  if (loading) {
    return null;
  }
  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Edit Organization
      </Typography>
      <OrganizationForm
        initialData={selectedOrganization ?? {}}
        disabledFields={['email', ...(user?.role === 'partner' ? ['features'] : [])]}
        onSubmit={handleUpdate}
        onCancel={handleCancel}
        is_embedded_partner={is_embedded_partner}
        buttonText="Update"
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OrganizationEditPage;
